import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { getBadgeStyles } from "../../../../components/ui/badgeColors";
import DateUtils from "../../../../utils/DateUtils";
import { getAvisoVencimiento } from "../../helpers/vencimiento";

/**
 * Fecha límite de un inventario con su aviso de vencimiento ("Vencido", "Hoy",
 * "Mañana") si aún se puede contar; "-" si no tiene fecha
 */
const FechaLimiteInventario = ({ inventario, prefijo = "", fontSize = 13 }) => {
    if (!inventario?.fechaLimite) return <Typography sx={{ fontSize, color: "#6c757d" }}>-</Typography>;

    const aviso = getAvisoVencimiento(inventario);
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography sx={{ fontSize, color: "#495057" }}>
                {prefijo}
                {DateUtils.formatearFecha(inventario.fechaLimite)}
            </Typography>
            {aviso && <Chip label={aviso.label} size="small" sx={getBadgeStyles(aviso.color, { height: 20, fontSize: 10 })} />}
        </Stack>
    );
};

export default React.memo(FechaLimiteInventario);
